module.exports = __webpack_public_path__ + "static/media/webp-icon.f223390d.svg";